import React from 'react';
import styled from 'styled-components';
import { getPageMessage } from '../../shared/constants/pageMessages';
import { VenueIndexView } from '../../shared/enum/EnumRepository';
import { useExhibitionVenueActions } from '../../shared/hooks/useApi/useExhibitionVenue';
import { useExhibitionVenueStore } from '../../shared/store/exhibitionVenueStore';
import { useLanguageStore } from '../../shared/store/languageStore';
import { EXHIBITION_VIEW_SELECTOR_LINE_HEIGHT } from '../../shared/util/exhibitionVenueIndex';

const ExhibitionViewSelector: React.FC = () => {
  useLanguageStore((state) => state.language);
  const view = useExhibitionVenueStore((state) => state.view);
  const { setView } = useExhibitionVenueActions();
  const isAllVenues = view === VenueIndexView.ALL_VENUES;
  const nextView = isAllVenues
    ? VenueIndexView.CURRENT_EXHIBITIONS
    : VenueIndexView.ALL_VENUES;

  return (
    <ViewOption
      type="button"
      onClick={() => setView(nextView)}
    >
      {getPageMessage(
        isAllVenues
          ? 'EXHIBITION_VIEW_CURRENT_EXHIBITIONS'
          : 'EXHIBITION_VIEW_ALL_VENUES',
      )}
    </ViewOption>
  );
};

const ViewOption = styled.button`
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  height: calc(${({ theme }) => theme.fontSize.font_B05} * ${EXHIBITION_VIEW_SELECTOR_LINE_HEIGHT});
  color: ${({ theme }) => theme.colors.color_Gray_04};
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s ease;
  ${({ theme }) => theme.typography.Footer_01};
  line-height: ${EXHIBITION_VIEW_SELECTOR_LINE_HEIGHT};

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.color_Gray_03};
  }
`;

export default ExhibitionViewSelector;
